function t(a, e = {
  maxChars: 5,
  pos: "start"
}) {
  if (a.length <= e.maxChars)
    return { isTruncated: !1, value: a };
  let r;
  switch (e.pos) {
    case "center": {
      const n = Math.floor(e.maxChars / 2), s = e.maxChars - n;
      r = `${a.substring(0, n)}...${a.substring(a.length - s)}`;
      break;
    }
    case "end": {
      r = `${a.substring(0, e.maxChars)}...`;
      break;
    }
    default: {
      r = `...${a.substring(a.length - e.maxChars)}`;
      break;
    }
  }
  return { isTruncated: !0, value: r };
}
export {
  t as truncate
};
